import { v4 as uuidv4 } from 'uuid';
import { createStore } from 'zustand/vanilla';

export type UserBrowserData = {
  browserId: string;
  sessionId: string;
};

type UserBrowserDataState = {
  identity: UserBrowserData | undefined;
};

export const userBrowserStore = createStore<UserBrowserDataState>(() => ({
  identity: undefined,
}));

const createEphemeralUserBrowserData = (): UserBrowserData => ({
  browserId: uuidv4(),
  sessionId: uuidv4(),
});

export const setUserBrowserData = (identity: UserBrowserData): void => {
  userBrowserStore.setState({ identity });
};

/**
 * Returns the current user browser data. If nothing has been seeded yet (dev, Storybook,
 * direct load, non-DOM tests), lazily mint an ephemeral in-memory value and
 * persist it for the session. Never touches document.cookie.
 */
export const getUserBrowserData = (): UserBrowserData => {
  const current = userBrowserStore.getState().identity;
  if (current) {
    return current;
  }
  const ephemeral = createEphemeralUserBrowserData();
  userBrowserStore.setState({ identity: ephemeral });
  return ephemeral;
};
